// extracted by mini-css-extract-plugin
export default {"modal":"NewShareModal_modal__-am5+","image":"NewShareModal_image__HvYmK"};